import useTranslation from 'next-translate/useTranslation'

import Modal from '../../../app/components/modal/Modal'
import useAppSelector from '../../../../store/hooks/useAppSelector'
import {
  checkoutCapacityConflictActiveOptionSelector,
  checkoutCapacityConflictAllocationSelector,
  checkoutCapacityConflictOptionsSelector,
  checkoutCapacityConflictSingleSelector,
  checkoutCapacityConflictTypeSelector,
} from '../../store/checkoutSelectors'
import { CapacityConflictType } from '../../types'
import getCapacityConflictTitle from '../../utils/getCapacityConflictTitle'
import useCapacityConflictActions from '../../hooks/useCapacityConflictActions'

import CapacityConflictSomeBlocked from './CapacityConflictSomeBlocked'
import CapacityConflictAllBlocked from './CapacityConflictAllBlocked'
import CapacityConflictModalHeader from './CapacityConflictModalHeader'
import CapacityConflictUnavailableStep from './CapacityConflictUnavailableStep'
import styles from './CheckoutCapacityConflictModal.module.scss'

export default function CheckoutCapacityConflictModal() {
  const { t } = useTranslation('common')
  const { cancel } = useCapacityConflictActions()

  const conflictType = useAppSelector(checkoutCapacityConflictTypeSelector)
  const allocation = useAppSelector(checkoutCapacityConflictAllocationSelector)
  const single = useAppSelector(checkoutCapacityConflictSingleSelector)
  const options = useAppSelector(checkoutCapacityConflictOptionsSelector)
  const activeOption = useAppSelector(
    checkoutCapacityConflictActiveOptionSelector,
  )

  function handleClose() {
    cancel()
  }

  if (conflictType === undefined || !allocation) {
    return null
  }

  const title = getCapacityConflictTitle(
    { type: conflictType, path: activeOption, single, verb: allocation.verb },
    t,
  )

  function renderContent() {
    // Nothing the guest can do from in here - no times, nothing to adjust, and no
    // order to delete. Offer them another day rather than an empty choice step.
    if (!options.length) {
      return <CapacityConflictUnavailableStep />
    }

    switch (conflictType) {
      case CapacityConflictType.SomeProductsBlocked:
        return <CapacityConflictSomeBlocked />

      case CapacityConflictType.AllProductsBlocked:
        return <CapacityConflictAllBlocked />

      default:
        return null
    }
  }

  return (
    <Modal
      isOpen
      title={title}
      contentClassName={styles.modalContent}
      mobileModalMode="bottom-sheet"
      pinBodyOnMobile
      onClose={handleClose}
      CustomModalHeader={CapacityConflictModalHeader}
    >
      <div className={styles.container}>{renderContent()}</div>
    </Modal>
  )
}
